/**
 * Shared frontend utilities.
 */

// Escapes text for safe interpolation into innerHTML (both element content
// and quoted attribute values). Almost all catalog data (channel/movie/
// series/episode/EPG titles) comes from an untrusted third-party IPTV
// provider, so anything provider-derived must go through this before being
// template-string'd into innerHTML - never trust it to already be safe.
function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

window.escapeHtml = escapeHtml;

// Basic focus management for the app's shared modal (#modal, reused by
// trailer/edit-user/etc dialogs): moves focus into the modal on open and
// restores it to whatever triggered the modal on close, so keyboard/screen-
// reader users don't lose their place. Call openModalFocus(modalEl) right
// after showing a modal, then call the function it returns once the modal
// is hidden again.
function openModalFocus(modalEl) {
    const previouslyFocused = document.activeElement;
    // Prefer the modal's own close button (always present, always a sane
    // place to land) over "first focusable child", which could be something
    // mid-form and disorienting to land on unannounced.
    const target = modalEl?.querySelector('.modal-close, [data-action="close"]') || modalEl;
    target?.focus?.();
    return function restoreModalFocus() {
        previouslyFocused?.focus?.();
    };
}

window.openModalFocus = openModalFocus;

// Standard trailing-edge debounce - was independently copy-pasted, byte-
// identical, into both MoviesPage.js and SeriesPage.js as a method on each
// class. NOT the same as EpgGuide.js's own debounce() (that one fires on
// the leading edge after the gap, a deliberately different variant for its
// own use) - left that one alone rather than risk changing its behavior.
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
    };
}

window.debounce = debounce;
